import React from 'react';

import {
  Typography,
  TypographyList,
  TypographyListItem,
} from '@gogame/components';

const Summary = () => {
  return (
    <div>
      <Typography gutterBottom={true}>
        Below please find a summary of certain material legal terms which apply
        to this IO:
      </Typography>
      <TypographyList spacing={1} type={'bullet'} disableTooltip={true}>
        <TypographyListItem>
          Termination Notice - Plarium and/or Publisher are required to provide
          2-business days written notice in order to terminate or alter the
          terms of this IO.
        </TypographyListItem>
        <TypographyListItem>
          Terms & Conditions – This IO, including the terms and conditions below
          supersede any other agreement signed by the parties. In the event of a
          contradiction between the provisions of the IO and the attached terms
          and conditions, the provisions of the IO shall prevail.
        </TypographyListItem>
      </TypographyList>
    </div>
  );
};

export default Summary;
